import 'core-js/stable';

import * as React from 'react';
import * as ReactDOM from 'react-dom';

import { loadClientTranslations } from '~l10n/client/translate';

import { AppView } from '../AppView';
// TODO: Some of these imports are probably not needed - RLP
// Although some of them have side effects. :(
import { setupSocrativeInterceptors } from '../src/api/localAxios';
import { dynamicImport } from '../src/util/dynamicImport';

require('../../shared/less/student.less');
require('extensions');

let user = require('user');
let room = require('room'); // eslint-disable-line
let popup = require('../../shared/components/popup/PopupController'); // eslint-disable-line
let Select = require('Select'); // eslint-disable-line
let DownChevronSmall = require('DownChevronSmall'); // eslint-disable-line
let InfoIcon = require('InfoIcon'); // eslint-disable-line

/* ---------------------------------------------------------------------------- */
let Backbone = require('backbone');

const StudentRouter = dynamicImport({
  moduleImport: () =>
    import(/* webpackChunkName: 'student-router' */ 'student-router'),
});

user.setModeSilent('student');
user.getCookieData();
setupSocrativeInterceptors();
loadClientTranslations(user.getLanguage()).then(() => {
  StudentRouter().then(() => {
    ReactDOM.render(
      React.createElement(AppView, { user: user }),
      document.getElementById('content-container')
    );
    SOCRATIVE.checkTime.reset();
    SOCRATIVE.initTemplateLoader.stop(); // Hide the loading message (if it's visible)
    Backbone.history.start();
  });
});
